// removed by extract-text-webpack-plugin
module.exports = {"FooterButton":"FooterButton__1YgXr","FooterContainer":"FooterContainer__3XMjb"};


//////////////////
// WEBPACK FOOTER
// ./routes/Footer/style.scss
// module id = cuVP
// module chunks = 0